// extracted by mini-css-extract-plugin
module.exports = {"TaskContentContainer":"Tasks_TaskContentContainer__SrdzX"};